const TAGS = /<[^>]*>/g;
const NON_BREAKING_SPACES = /&nbsp;|\u00a0/g;

// A rich text emptied in its editor keeps its markup (« <p></p> »).
const hasVisibleText = (html: string | null | undefined): boolean =>
  !!html?.replace(TAGS, '').replace(NON_BREAKING_SPACES, ' ').trim();

export interface QuotationHeaderConditionsInput {
  readonly note?: string | null;
  readonly modalities?: string | null;
  readonly interventionDate?: string | null;
}

// The nota shows the intervention date too.
export const hasNota = ({
  note,
  interventionDate,
}: Readonly<QuotationHeaderConditionsInput>): boolean =>
  hasVisibleText(note) || !!interventionDate;

export const hasModalities = ({
  modalities,
}: Readonly<QuotationHeaderConditionsInput>): boolean =>
  hasVisibleText(modalities);
